import React from "react"
import styled from "styled-components"
import { Link } from "react-router-dom"
import { compose, lifecycle } from "recompose"
import { FormattedMessage } from "react-intl"

import Text from "../../components/text"
import Box from "../../lib/ui/ui-box"
import Logo from "../../components/logo"

const Header = styled.div`
  width: 100%;
  height: 500px;
  background-image: url(images/backgrounds/dining-room.png);
  background-size: cover;
  background-position: center center;
`

const Overlay = styled.div`
  display: flex;
  width: 100%;
  height: 100%;
  background-color: rgba(44, 43, 89, 0.5);
  align-items: center;
  justify-content: center;
`

const Page = props => {
  return (
    <Box flexDirection="column" align="center" py={[5]}>
      <Box
        align="flex-start"
        justify="center"
        w={["80%", "80%", "80%", "1000px"]}
        flexDirection="column"
      >
        <Box flexDirection="column" align="flex-start" pl={[1]} pb={[1]}>
          <Link to="/">
            <Logo src="logo/Nesto_Equity_Logo.png" alt="Nesto Logo" />
          </Link>
        </Box>
        <Box flexDirection="column">
          <Header>
            <Overlay>
              <Text
                color="white"
                fontFamily="Libre Baskerville"
                fontSize={[5]}
                fontWeight="400"
                lineHeight={[5]}
              >
                <FormattedMessage id="terms.title" />
              </Text>
            </Overlay>
          </Header>
          <Box flexDirection="column" pt={[2]}>
            <Box flexDirection="column">
              <Text fontSize={[3]} lineHeight={[3]}>
                <FormattedMessage id="terms.overview.title" />
              </Text>
              <Text fontSize={[2]} lineHeight={[2]}>
                <FormattedMessage id="terms.overview.paragraph1" />
              </Text>
            </Box>

            <Box flexDirection="column" pt={[2]}>
              <Text fontSize={[2]} lineHeight={[2]}>
                <FormattedMessage id="terms.overview.paragraph2" />
              </Text>
            </Box>

            <Box flexDirection="column" pt={[2]}>
              <Text fontSize={[2]} lineHeight={[2]}>
                <FormattedMessage id="terms.overview.paragraph3" />
              </Text>
            </Box>

            <Box flexDirection="column" pt={[2]}>
              <Text fontSize={[2]} lineHeight={[2]}>
                <FormattedMessage id="terms.overview.paragraph4" />
              </Text>
            </Box>

            <Box flexDirection="column" pt={[2]}>
              <Text fontSize={[2]} lineHeight={[2]}>
                <FormattedMessage id="terms.overview.paragraph5" />
              </Text>
            </Box>

            <Box flexDirection="column" pt={[2]}>
              <Text fontSize={[2]} lineHeight={[2]}>
                <FormattedMessage id="terms.section1.title" />
              </Text>
            </Box>

            <Box flexDirection="column" pt={[2]}>
              <Text fontSize={[2]} lineHeight={[2]}>
                <FormattedMessage id="terms.section1.paragraph1" />
              </Text>
            </Box>

            <Box flexDirection="column" pt={[2]}>
              <Text fontSize={[2]} lineHeight={[2]}>
                <FormattedMessage id="terms.section2.title" />
              </Text>
            </Box>

            <Box flexDirection="column" pt={[2]}>
              <Text fontSize={[2]} lineHeight={[2]}>
                <FormattedMessage id="terms.section2.paragraph1" />
              </Text>
            </Box>

            <Box flexDirection="column" pt={[2]}>
              <Text fontSize={[2]} lineHeight={[2]}>
                <FormattedMessage id="terms.section3.title" />
              </Text>
            </Box>

            <Box pt={[2]}>
              <Text fontSize={[2]} lineHeight={[2]}>
                <FormattedMessage id="terms.section3.paragraph1" />
              </Text>
            </Box>

            <Box pt={[2]}>
              <Text fontSize={[2]} lineHeight={[2]}>
                <FormattedMessage id="terms.section3.paragraph2" />
              </Text>
            </Box>

            <Box pt={[2]}>
              <Text fontSize={[2]} lineHeight={[2]}>
                <FormattedMessage id="terms.section4.title" />
              </Text>
            </Box>

            <Box pt={[2]}>
              <Text fontSize={[2]} lineHeight={[2]}>
                <FormattedMessage id="terms.section4.paragraph1" />
              </Text>
            </Box>

            <Box pt={[2]}>
              <Text fontSize={[2]} lineHeight={[2]}>
                <FormattedMessage id="terms.section5.title" />
              </Text>
            </Box>

            <Box pt={[2]}>
              <Text fontSize={[2]} lineHeight={[2]}>
                <FormattedMessage id="terms.section5.paragraph1" />
              </Text>
            </Box>

            <Box pt={[2]}>
              <Text fontSize={[2]} lineHeight={[2]}>
                <FormattedMessage id="terms.section5.paragraph2" />
              </Text>
            </Box>

            <Box pt={[2]}>
              <Text fontSize={[2]} lineHeight={[2]}>
                <FormattedMessage id="terms.section5.paragraph3" />
              </Text>
            </Box>

            <Box pt={[2]}>
              <Text fontSize={[2]} lineHeight={[2]}>
                <FormattedMessage id="terms.section5.paragraph4" />
              </Text>
            </Box>

            <Box pt={[2]}>
              <Text fontSize={[2]} lineHeight={[2]}>
                <FormattedMessage id="terms.section5.paragraph5" />
              </Text>
            </Box>

            <Box pt={[2]}>
              <Text fontSize={[2]} lineHeight={[2]}>
                <FormattedMessage id="terms.section6.title" />
              </Text>
            </Box>

            <Box pt={[2]}>
              <Text fontSize={[2]} lineHeight={[2]}>
                <FormattedMessage id="terms.section6.paragraph1" />
              </Text>
            </Box>

            <Box pt={[2]}>
              <Text fontSize={[2]} lineHeight={[2]}>
                <FormattedMessage id="terms.section6.paragraph2" />
              </Text>
            </Box>

            <Box pt={[2]}>
              <Text fontSize={[2]} lineHeight={[2]}>
                <FormattedMessage id="terms.section6.paragraph3" />
              </Text>
            </Box>

            <Box pt={[2]}>
              <Text fontSize={[2]} lineHeight={[2]}>
                <FormattedMessage id="terms.section6.paragraph4" />
              </Text>
            </Box>

            <Box pt={[2]}>
              <Text fontSize={[2]} lineHeight={[2]}>
                <FormattedMessage id="terms.section7.title" />
              </Text>
            </Box>

            <Box pt={[2]}>
              <Text fontSize={[2]} lineHeight={[2]}>
                <FormattedMessage id="terms.section7.paragraph1" />
              </Text>
            </Box>

            <Box pt={[2]}>
              <Text fontSize={[2]} lineHeight={[2]}>
                <FormattedMessage id="terms.section8.title" />
              </Text>
            </Box>

            <Box pt={[2]}>
              <Text fontSize={[2]} lineHeight={[2]}>
                <FormattedMessage id="terms.section8.paragraph1" />
              </Text>
            </Box>

            <Box pt={[2]}>
              <Text fontSize={[2]} lineHeight={[2]}>
                <FormattedMessage id="terms.section9.title" />
              </Text>
            </Box>

            <Box pt={[2]}>
              <Text fontSize={[2]} lineHeight={[2]}>
                <FormattedMessage id="terms.section9.paragraph1" />
              </Text>
            </Box>

            <Box pt={[2]}>
              <Text fontSize={[2]} lineHeight={[2]}>
                <FormattedMessage id="terms.section10.title" />
              </Text>
            </Box>

            <Box pt={[2]}>
              <Text fontSize={[2]} lineHeight={[2]}>
                <FormattedMessage id="terms.section10.paragraph1" />
              </Text>
            </Box>

            <Box pt={[2]}>
              <Text fontSize={[2]} lineHeight={[2]}>
                <FormattedMessage id="terms.section10.paragraph2" />
              </Text>
            </Box>

            <Box pt={[2]}>
              <Text fontSize={[2]} lineHeight={[2]}>
                <FormattedMessage id="terms.section10.paragraph3" />
              </Text>
            </Box>

            <Box pt={[2]}>
              <Text fontSize={[2]} lineHeight={[2]}>
                <FormattedMessage id="terms.section11.title" />
              </Text>
            </Box>

            <Box pt={[2]}>
              <Text fontSize={[2]} lineHeight={[2]}>
                <FormattedMessage id="terms.section11.paragraph1" />
              </Text>
            </Box>

            <Box pt={[2]}>
              <Text fontSize={[2]} lineHeight={[2]}>
                <FormattedMessage id="terms.section12.title" />
              </Text>
            </Box>

            <Box pt={[2]}>
              <Text fontSize={[2]} lineHeight={[2]}>
                <FormattedMessage id="terms.section12.paragraph1" />
              </Text>
            </Box>

            <Box pt={[2]}>
              <Text fontSize={[2]} lineHeight={[2]}>
                <FormattedMessage id="terms.section13.title" />
              </Text>
            </Box>

            <Box pt={[2]}>
              <Text fontSize={[2]} lineHeight={[2]}>
                <FormattedMessage id="terms.section13.paragraph1" />
              </Text>
            </Box>

            <Box pt={[2]}>
              <Text fontSize={[2]} lineHeight={[2]}>
                <FormattedMessage id="terms.section13.paragraph2" />
              </Text>
            </Box>

            <Box pt={[2]}>
              <Text fontSize={[2]} lineHeight={[2]}>
                <FormattedMessage id="terms.section13.paragraph3" />
              </Text>
            </Box>

            <Box pt={[2]}>
              <Text fontSize={[2]} lineHeight={[2]}>
                <FormattedMessage id="terms.section14.title" />
              </Text>
            </Box>

            <Box pt={[2]}>
              <Text fontSize={[2]} lineHeight={[2]}>
                <FormattedMessage id="terms.section14.paragraph1" />
              </Text>
            </Box>

            <Box pt={[2]}>
              <Text fontSize={[2]} lineHeight={[2]}>
                <FormattedMessage id="terms.section14.paragraph2" />
              </Text>
            </Box>

            <Box pt={[2]}>
              <Text fontSize={[2]} lineHeight={[2]}>
                <FormattedMessage id="terms.section14.paragraph3" />
              </Text>
            </Box>

            <Box pt={[2]}>
              <Text fontSize={[2]} lineHeight={[2]}>
                <FormattedMessage id="terms.section15.title" />
              </Text>
            </Box>

            <Box pt={[2]}>
              <Text fontSize={[2]} lineHeight={[2]}>
                <FormattedMessage id="terms.section15.paragraph1" />
              </Text>
            </Box>

            <Box pt={[2]}>
              <Text fontSize={[2]} lineHeight={[2]}>
                <FormattedMessage id="terms.section16.title" />
              </Text>
            </Box>

            <Box pt={[2]}>
              <Text fontSize={[2]} lineHeight={[2]}>
                <FormattedMessage id="terms.section16.paragraph1" />
              </Text>
            </Box>

            <Box pt={[2]}>
              <Text fontSize={[2]} lineHeight={[2]}>
                <FormattedMessage id="terms.section16.paragraph2" />
              </Text>
            </Box>
          </Box>
        </Box>
      </Box>
    </Box>
  )
}

export default compose(
  lifecycle({
    componentDidMount() {
      window.scrollTo(0, 0)
    }
  })
)(Page)



// WEBPACK FOOTER //
// ./src/containers/terms/index.js